import { useQuery } from '@tanstack/react-query';
import { DIAM_API_PATH, getInvitationsPage } from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';

export function useInvitationsPendingCount() {
  const { getIdToken, apiUrl, isSignedIn } = useApiEssentials(DIAM_API_PATH);

  return useQuery({
    queryKey: ['diam', 'invitations', 'pending-count'] as const,
    queryFn: async () => {
      const idToken = await getIdToken();
      return getInvitationsPage(apiUrl, idToken, {
        page: 0,
        limit: 1,
        filter: { status: 'PENDING' },
      });
    },
    enabled: isSignedIn,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
